import { render, staticRenderFns } from "./ViewCustomerComponent.vue?vue&type=template&id=74e185f9&"
import script from "./ViewCustomerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports